import { render, staticRenderFns } from "./DevolucionCreate.vue?vue&type=template&id=2801260c&scoped=true&"
import script from "./DevolucionCreate.vue?vue&type=script&lang=js&"
export * from "./DevolucionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801260c",
  null
  
)

export default component.exports